import { useParams } from 'react-router-dom';

import { refetchSnapDetailsAction, snapStore } from 'containers/Snaps/Snap/store';
import { CRUDTable } from 'components';

import { useDeleteRequest, usePatchRequest, usePostRequest } from 'hooks';

import { CreateLineItemRequest, SnapDetailsLineItem } from 'codegen';

import {
  columns,
  handleDeleteLineItem,
  handlePatchLineItem,
  handlePostLineItem,
  initialTableActions,
} from './lib';

export const LineItems = () => {
  const lineItems = snapStore((state) => state.lineItems);
  const isLineItemsCreationAllowed = snapStore((state) => state.snapBooleanStatuses.isLineItemsCreationAllowed);

  const { snapId } = useParams();

  const [postLineItem, { loading }] = usePostRequest<SnapDetailsLineItem, CreateLineItemRequest>({
    url: 'snaps/details/items',
    options: {
      onSuccess: refetchSnapDetailsAction,
    },
  });

  const [patchLineItem, { loading: patchLoading }] = usePatchRequest<SnapDetailsLineItem, SnapDetailsLineItem>({
    options: {
      onSuccess: refetchSnapDetailsAction,
    },
  });

  const [deleteLineItem, { loading: deleteLoading }] = useDeleteRequest({
    options: {
      onSuccess: refetchSnapDetailsAction,
    },
  });

  const isLoading = loading || patchLoading || deleteLoading;

  return (
    <CRUDTable
      id='line-items'
      title='Line Items'
      columns={columns}
      loading={isLoading}
      dataSource={lineItems}
      addNewBtn={{ visible: !!isLineItemsCreationAllowed }}
      initialTableActions={initialTableActions}
      onPostTableData={handlePostLineItem(postLineItem, snapId)}
      onPatchTableData={handlePatchLineItem(patchLineItem)}
      onDeleteTableData={handleDeleteLineItem(deleteLineItem, snapId)}
    />
  );
};
